module.exports = __webpack_public_path__ + "static/media/login-logo.acb5a379.svg";